import React, {useContext} from "react";
import {SearchContext} from "../components/SearchContext.js";

const OfferLink = ({link, heading, name, ofId}) => {
    const {doCustomSearch} = useContext(SearchContext);

    return <a href={link === null ? "#" : link} onClick={e => {
        if (!link) {
            e.preventDefault();
            doCustomSearch([{"filter":`filters[groupOffers][${ofId}][checked]`,"value":"1"}]);
        }
    }} className="offerLink" ofId={ofId}>
        <h4 className="offerHeading"><i class='fas fa-tag'></i>{heading}</h4>
        <p class='offerName'>{name}</p>
    </a>
}

export default OfferLink;